export default "__VITE_ASSET__C2q0wHDo__"